import { createRoot } from 'react-dom/client';
import App from 'App';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { theme } from 'theme';
import 'index.css';

function loadDynatraceRum() {
  const rumUrl = process.env.REACT_APP_DYNATRACE_RUM_URL;
  if (!rumUrl) {
    console.warn('Dynatrace RUM URL not configured in environment variables.');
    return;
  }

  const script = document.createElement('script');
  script.src = rumUrl;
  script.type = 'text/javascript';
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
}

// Load RUM before rendering the app
loadDynatraceRum();


const root = createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
  </ThemeProvider>
);
